import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import App from "./App";
import StartFromTop from "./helpers/StartFromTop";
import { CatalogContextProvider } from "./contexts/CatalogContextProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <CatalogContextProvider>
      <StartFromTop />
      <App />
    </CatalogContextProvider>
  </BrowserRouter>
);
